<template>
  <div class="addCameraManagement-page">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <div class="title-back">
              <h4>添加摄像头</h4>
              <p class="backBth" @click="canlan">
                <i class="el-icon-caret-left"></i>
                <span>返回</span>
              </p>
            </div>
          </div>
        </div>
        <div class="table-content">
          <el-form
            label-position="right"
            label-width="120px"
            :model="formLabelAlign"
            ref="formLabelAlign"
            :rules="rules"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="设备名称：" prop="name">
                  <el-input
                    v-model="formLabelAlign.name"
                    maxlength="20"
                    clearable
                    placeholder="请输入设备名称"
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备编码：" prop="code">
                  <el-input
                    v-model="formLabelAlign.code"
                    maxlength="20"
                    clearable
                    placeholder="请输入设备编码"
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="模板类型：" prop="modelRuleDeviceId">
                  <el-select
                    v-model="formLabelAlign.modelRuleDeviceId"
                    placeholder="请选择模板类型"
                    class="inputW"
                  >
                    <el-option
                      v-for="item in modelRuleDeviceIdList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属分组：" prop="groupId">
                  <el-cascader
                    class="inputW"
                    @change="changeTreeItem"
                    :show-all-levels="false"
                    v-model="formLabelAlign.groupId"
                    :options="departList"
                    :props="optionProps"
                    clearable
                    placeholder="请选择所属分组"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="协议类型：" prop="protocolType">
                  <el-select
                    v-model="formLabelAlign.protocolType"
                    placeholder="请选择协议类型"
                    class="inputW"
                  >
                    <el-option
                      v-for="item in protocolTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="视频类型：" prop="videoType">
                  <el-select
                    v-model="formLabelAlign.videoType"
                    placeholder="请选择视频类型"
                    class="inputW"
                  >
                    <el-option label="普通视频" value="0"></el-option>
                    <el-option label="云台视频" value="1"></el-option>
                    <el-option label="轨道视频" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="萤石序列号：" prop="ysAppCode">
                  <el-input
                    v-model="formLabelAlign.ysAppCode"
                    maxlength="60"
                    clearable
                    placeholder="请输入萤石序列号"
                    class="inputW"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="萤石通道号：" prop="ysAppChannelNo">
                  <el-input-number
                    placeholder="请输入萤石通道号"
                    v-model="formLabelAlign.ysAppChannelNo"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="9999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="萤石appKey：" prop="ysAppKey">
              <el-input
                v-model="formLabelAlign.ysAppKey"
                maxlength="200"
                clearable
                placeholder="请输入萤石appKey"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="萤石appSecret："
              prop="ysAppSecret"
              label-width="130px"
              style="margin-left: -10px"
            >
              <el-input
                v-model="formLabelAlign.ysAppSecret"
                maxlength="200"
                clearable
                placeholder="请输入萤石appSecret"
              ></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="生产日期：" prop="pdate">
                  <el-date-picker
                    v-model="formLabelAlign.pdate"
                    type="date"
                    placeholder="请选择生产日期"
                    class="inputW"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采集数据间隔：" prop="intervalTime">
                  <el-input-number
                    placeholder="请输入采集数据间隔(秒)"
                    v-model="formLabelAlign.intervalTime"
                    :precision="0"
                    :step="1"
                    :min="0"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="经度：">
                  <el-input-number
                    placeholder="请输入经度"
                    v-model="formLabelAlign.longitude"
                    :precision="6"
                    :step="1"
                    :min="-99999999"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纬度：">
                  <el-input-number
                    placeholder="请输入纬度"
                    v-model="formLabelAlign.dimension"
                    :precision="6"
                    :step="1"
                    :min="-99999999"
                    :max="99999999"
                    size="small"
                    clearable
                    class="inputW"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="ezopen地址：" prop="playAddr">
              <el-input
                v-model="formLabelAlign.playAddr"
                maxlength="200"
                placeholder="请输入ezopen地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="m3u8地址：" prop="playM3u8">
              <el-input
                v-model="formLabelAlign.playM3u8"
                maxlength="200"
                placeholder="请输入m3u8地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="rtmp地址：" prop="playRtmp">
              <el-input
                v-model="formLabelAlign.playRtmp"
                maxlength="200"
                placeholder="请输入rtmp地址"
              ></el-input>
            </el-form-item>
            <el-form-item style="text-align: center">
              <el-button @click="canlan">取 消</el-button>
              <el-button type="primary" @click="submitForm('formLabelAlign')"
                >确 定</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
      },
      protocolTypeList: [
        //协议类型(0：sdk，1：onvif,2：rtsp，3：gb28181）
        {
          id: 0,
          name: "sdk",
        },
        {
          id: 1,
          name: "onvif",
        },
        {
          id: 2,
          name: "rtsp",
        },
        {
          id: 3,
          name: "gb28181",
        },
      ],
      departList: [],
      modelRuleDeviceIdList: [],
      options: [
        {
          value: "选项1",
          label: "传感树001",
        },
        {
          value: "选项2",
          label: "传感树002",
        },
        {
          value: "选项3",
          label: "传感树004",
        },
        {
          value: "选项4",
          label: "传感树004",
        },
        {
          value: "选项5",
          label: "传感树005",
        },
      ],
      value: "传感树001",
      name: "",
      formLabelAlign: {
        groupId: "",
        modelRuleDeviceId: "",
        protocolType: "",
        code: "",
        ysAppSecret: "",
        ysAppKey: "",
        ysAppCode: "",
        intervalTime: "",
        pdate: "",
        longitude: undefined,
        dimension: undefined,
        playAddr: "",
        playM3u8: "",
        playRtmp: "",
        name: "",
        modelRuleDeviceId: "",
        protocolType: "",
        videoType: "",
        ysAppChannelNo: "",
      },
      rules: {
        // 弹框表单验证
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入设备编码", trigger: "blur" }],
        paramType: [
          { required: true, message: "请选择参数类型", trigger: "change" },
        ],
        groupId: [
          { required: true, message: "请选择所属分组", trigger: "change" },
        ],
        gatewayId: [
          { required: true, message: "请选择所属网关", trigger: "change" },
        ],
        modelRuleDeviceId: [
          { required: true, message: "请选择模板类型", trigger: "change" },
        ],
        protocolType: [
          { required: true, message: "请选择协议类型", trigger: "change" },
        ],
        pdate: [
          { required: true, message: "请选择生产日期", trigger: "change" },
        ],
        videoType: [
          { required: true, message: "请选择视频类型", trigger: "change" },
        ],
        ysAppCode: [
          { required: true, message: "请输入萤石序列号", trigger: "blur" },
        ],
        ysAppChannelNo: [
          { required: true, message: "请输入萤石通道号", trigger: "blur" },
        ],
        ysAppKey: [
          { required: true, message: "请输入萤石appKey", trigger: "blur" },
        ],
        ysAppSecret: [
          { required: true, message: "请输入萤石appSecret", trigger: "blur" },
        ],
        playAddr: [
          { required: true, message: "请输入ezopen地址", trigger: "blur" },
        ],
        playM3u8: [
          { required: true, message: "请输入m3u8地址", trigger: "blur" },
        ],
        playRtmp: [
          { required: true, message: "请输入rtmp地址", trigger: "blur" },
        ],
        intervalTime: [
          { required: true, message: "请输入采集数据间隔", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getVideo(this.$route.query.id);
    this.id = this.$route.query.id;
    this.getModelRuleDevices();
    this.getConfigGroupTree();
  },
  methods: {
    submitForm(formName) {
      // 提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    //所属分组id
    changeTreeItem(val) {
      this.formLabelAlign.groupId = val[val.length - 1];
    },
    //查询全部设备类型模板
    getModelRuleDevices() {
      this.$api.system
        .getModelRuleDevices()
        .then((res) => {
          if (res.code == 200) {
            this.modelRuleDeviceIdList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0 //主键id ，根据具体业务进行判定
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询摄像头详情
    getVideo(id) {
      if (id == undefined) {
        return false;
      }
      this.$api.system.getVideo(id).then((res) => {
        if (res.code == 200) {
          res.data.videoType =
            res.data.videoType != undefined
              ? res.data.videoType.toString()
              : "";
          this.formLabelAlign = res.data;
        }
      });
    },
    canlan() {
      this.$router.push({
        name: "deviceManagement",
        query: {
          currentShow: "second",
          currentShow1: "second",
        },
      });
    },
    //提交
    submit() {
      this.saveVideo();
    },

    zhDatetime(t) {
      if (t == "" || t == null || t == undefined) {
        return "";
      } else {
        var d = new Date(t);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var h = d.getHours();
        var m = d.getMinutes();
        var s = d.getSeconds();
        M = M > 9 ? M : "0" + M;
        D = D > 9 ? D : "0" + D;
        h = h > 9 ? h : "0" + h;
        m = m > 9 ? m : "0" + m;
        s = s > 9 ? s : "0" + s;
        return Y + "-" + M + "-" + D + " " + h + ":" + m + ":" + s;
      }
    },
    // 保存摄像头
    saveVideo() {
      var time = this.zhDatetime(this.formLabelAlign.pdate);
      if (this.id == undefined) {
        this.id = "";
      }
      let data = new FormData();
      data.append("code", this.formLabelAlign.code);
      data.append("ysAppSecret", this.formLabelAlign.ysAppSecret);
      data.append("ysAppKey", this.formLabelAlign.ysAppKey);
      data.append("ysAppCode", this.formLabelAlign.ysAppCode);
      data.append("intervalTime", this.formLabelAlign.intervalTime);
      data.append("pdate", time);
      data.append("longitude", this.formLabelAlign.longitude);
      data.append("groupId", this.formLabelAlign.groupId);
      data.append("dimension", this.formLabelAlign.dimension);
      data.append("dimension", this.formLabelAlign.dimension);
      data.append("playAddr", this.formLabelAlign.playAddr);
      data.append("playM3u8", this.formLabelAlign.playM3u8);
      data.append("playRtmp", this.formLabelAlign.playRtmp);
      data.append("name", this.formLabelAlign.name);
      data.append("modelRuleDeviceId", this.formLabelAlign.modelRuleDeviceId);
      data.append("id", this.id);
      data.append("protocolType", this.formLabelAlign.protocolType);
      data.append("ysAppChannelNo", this.formLabelAlign.ysAppChannelNo);
      data.append("videoType", this.formLabelAlign.videoType);
      this.$api.system
        .saveVideo(data)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.$router.push({
              name: "deviceManagement",
              query: {
                currentShow: "second",
                currentShow1: "second",
              },
            });
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/addCameraManagement.scss";
li {
  padding-left: 15px;
}
.inputW {
  width: 230px !important;
}
</style>